import { toZonedTime } from 'date-fns-tz'
import { TFunction } from 'i18next'

import { EMPTY_VALUE } from '@/constants'
import { SurveyDetails } from '@/models'
import { formatDateOnly } from '@/utils/date'

export const prepareFrequency = (
  details: SurveyDetails | undefined,
  timezone: string | undefined,
  t: TFunction<['communication']>,
) => {
  if (!details || !timezone) return EMPTY_VALUE

  const { startDate, endDate, isOneTime } = details
  const preparedEndDate = endDate ? formatDateOnly(toZonedTime(endDate, timezone)) : ''

  return `${formatDateOnly(toZonedTime(startDate!, timezone))} - ${
    isOneTime ? preparedEndDate : t('communication:surveyDetails.frequency.ongoing')
  }`
}
